<template>
    <div class="payment">
        <div class="payment-header">
            <span class="active">銀行轉賬</span>
        </div>
        <div class="payment-main">
            <div class="bank">
                <div class="payment-method">銀行轉賬</div>
                <p>你可透過ATM轉賬或銀行櫃台入數到以下戶口：</p>
                <table class="table_nobor" style="margin: 30px 0; width: 100%">
                    <tr height="100">
                        <td align="left" width="250">
                            <img src="../../assets/chinabank.jpg" alt width="200" />
                        </td>
                        <td align="left">
                            <p>
                                中銀香港(代碼：012)：875-2-035677-8
                                <br />賬戶名稱：HOUSE730 LIMITED
                            </p>
                        </td>
                    </tr>
                    <tr height="10">
                        <td align="left" width="280">
                            <img src="../../assets/hangsengbank.jpg" alt width="200" />
                        </td>
                        <td align="left">
                            <p>
                                恒生银行(代碼：024)：752-007526-883
                                <br />賬戶名稱：HOUSE730 LIMITED
                            </p>
                        </td>
                    </tr>
                    <tr height="10">
                        <td align="left" width="280">
                            <img src="../../assets/hsbc_logo.png" alt width="200" />
                        </td>
                        <td align="left">
                            <p>
                                滙豐銀行 (代碼：004)：023-786478-838
                                <br />賬戶名稱：HOUSE730 LIMITED
                            </p>
                        </td>
                    </tr>
                    <tr height="80">
                        <td align="left" width="280">
                            <img src="../../assets/PMS_FPS.png" alt width="200" />
                        </td>
                        <td align="left">
                            <p>
                                FPS轉數快系統識別碼：3575503
                                <br />賬戶名稱：HOUSE730 LIMITED
                            </p>
                        </td>
                    </tr>
                </table>

                <p class="lineB f13">轉賬後，請在入數紙寫上你的手提電話/訂單編號，並用以下其中一個方法通知我們：</p>
                <p class="lineB f13">(1) 傳真：852-3619 3201。</p>
                <p class="lineB f13">(2) WhatsApp：852-5726 6308。</p>
                <p class="lineB f13" style="margin-bottom: 25px">(3) 電郵：support@house730.com ，電郵標題請註明：“payment to House730”。</p>
                <p class="lineB f13">一般情況下，我們會在下一個工作天內更新會員帳號及樓盤的相關資料。</p>
            </div>
        </div>
        <div class="payment-header mt-20">
            <span class="active">PayPal/信用卡</span>
        </div>
        <div class="payment-main">
            <div class="payPal">
                <div class="payment-method">PayPal/信用卡</div>
                <p>你可選擇PayPal/信用卡付款，House730並不會儲存或處理你的信用卡資料。</p>
                <p>如有任何問題，歡迎與我們聯絡 WhatsApp：852-5726 6308 / Email：support@house730.com / Tel：852-3619-3200。</p>
            </div>
        </div>
    </div>
</template>
<script>
export default {
    name: 'payment',
    data() {
        return {
            isActive: 1 // 1 組別用戶 2 個人用戶
        };
    },
    methods: {
        setActive(val) {
            this.isActive = val;
        }
    }
};
</script>
<style lang="less" scoped>
.payment {
    font-size: 14px;
    text-align: left;
    // .payment-header {
    //   font-size: 24px;
    //   margin: 18px 0px 24px;
    // }
    .payment-header {
        padding-bottom: 24px;
        span {
            display: inline-block;
            margin-right: 60px;
            font-size: 24px;
            color: #92929d;
            letter-spacing: 0.1px;
            // cursor: pointer;
        }
        span.active {
            color: #171725;
        }
    }
    .payment-main {
        padding: 10px 15px 20px;
        background-color: #fff;
        border-radius: 10px;
        .payment-method {
            font-size: 20px;
            font-weight: 600;
            margin-bottom: 25px;
            margin-top: 25px;
        }
    }
    .mt-20 {
        margin-top: 20px;
    }
}
</style>
